import { PlessViewUtilsSub } from './../../../commons/kymw00/pless-view-utils-sub.service';
import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW1313Model } from './kymw1313.model';
import { PlessDialogServiceSub } from '../../../../../src/app/commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { FlexGrid, SelectionMode } from '@grapecity/wijmo.grid';
import { KYMW1313InputModel } from './vo/kymw1313-input.model';
import { KYMW1313OutputModel } from './vo/kymw1313-output.model';
import { GetSetPlanPromotionGoodsListService } from './api-services/get-set-plan-promotion-goods-list.service';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { KYMW1313GetSetPlanPromotionGoodsInfoModel } from './vo/kymw1313-get-set-plan-promotion-goods-info.model';
import { TextInputComponent } from 'src/app/commons/kymw02/text-input/text-input/text-input.component';

/**
 * セット企画検索画面を管理するクラス
 *
 * @export KYMW1313Component
 * @class KYMW1313Component
 */
@Component({
  selector: 'app-kymw1313',
  templateUrl: 'kymw1313.component.html',
  styleUrls: ['kymw1313.component.scss'],
  encapsulation: ViewEncapsulation.None
})


export class KYMW1313Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  inputVO: KYMW1313InputModel = new KYMW1313InputModel();

  kymw1313Model: KYMW1313Model = new KYMW1313Model();

  setKYMW1313Parameter: Function;

  // 画面項目
  @ViewChild('dtg_PromotionGoods', { static: true }) dtg_PromotionGoods: FlexGrid;
  @ViewChild('txt_PromotionName', { static: true }) txt_PromotionName: TextInputComponent;
  @ViewChild('btn_Search', { static: true }) public btn_Search: ElementRef;

  // ウィンドウを閉じる際の処理
  closeFunction: Function;
  selfManage: KYMW1313Model;
  /**
   *Creates an instance of KYMW1313Component.
   * @param {PlessDialogService} dialogService
   * @memberof KYMW1313Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getSetPlanPromotionGoodsListService: GetSetPlanPromotionGoodsListService,
  ) {
    super(kymw00Model);
  }

  public setInputVO(inputVO: any): void {
    // 受渡情報の設定（再描画時）
    this.inputVO = <KYMW1313InputModel>(inputVO);
    // 画面初期化
    this.ngOnInit();
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1313';
    this.kymw1313Model.kymw1313Component = this;
    this.selfManage = this.kymw1313Model;
    this.dtg_PromotionGoods.columnHeaders.rows[0].height = 72;
    this.dtg_PromotionGoods.selectionMode = SelectionMode.Row;
    this.dtg_PromotionGoods.itemsSourceChanged.addHandler(() => {
      this.dtg_PromotionGoods.select(-1, -1);
    });
    // 受注コード
    this.kymw1313Model.orderCode = this.inputVO.orderCode;
    // プロモーション区分
    this.kymw1313Model.promotionDiv = this.inputVO.promotionDiv;
    // プロモーション名称
    this.kymw1313Model.promotionName = this.inputVO.promotionName;
    // Ｐコード
    this.kymw1313Model.pCode = this.inputVO.pCode;
    // セット企画商品名
    this.kymw1313Model.setDelivGoodsName = this.inputVO.setDelivGoodsName;
    // 会員生協
    this.kymw1313Model.coop = this.inputVO.coopCode;
    // 部門コード
    this.kymw1313Model.classCode = this.inputVO.classCode;
    // プロモーション情報
    this.kymw1313Model.promotionInfo = new Array<any>();

    

    this.txt_PromotionName.setFocus();
  }

  /*--------------------------------------------------------------------------------------------
  /* event area
  /*--------------------------------------------------------------------------------------------*/
  /**
   * 検索ボタン_クリック時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventSearch_CLICKHandler(event: Event): void {

    const vo: KYMW1313OutputModel = new KYMW1313OutputModel();
    // 処理区分
    vo.accessDiv = '1';
    // プロモーション区分
    vo.promotionDiv = this.kymw1313Model.promotionDiv;
    // プロモーション名称
    vo.promotionName = this.kymw1313Model.promotionName;
    // Ｐコード
    vo.pCode = this.kymw1313Model.pCode;
    // セット企画商品名
    vo.setDelivGoodsName = this.kymw1313Model.setDelivGoodsName;
    // 生協コード
    vo.coopCode = this.kymw1313Model.coop;
    // 部門コード
    vo.classCode = this.kymw1313Model.classCode;

    // 呼出元画面に検索条件,選択行を返却する
    this.setKYMW1313Parameter(vo);

    // プロモーション商品情報取得要求をサーバに送信
    this.getSetPlanPromotionGoodsListService.execute(this.kymw1313Model, this.createGetSetPlanPromotionGoodsInfoVO());
  }

  /**
   * 選択ボタン_クリック時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventSelect_CLICKHandler(event: Event): void {

    // 未選択時、処理中断
    if (PlessViewUtilsSub.isEmptyArray(this.dtg_PromotionGoods.selectedItems)) {
      this.dialogService.openAlertGetMessage('E0103', ['商品'], null);
      return;
    }

    if (this.parent.editCount > 0) {

      // 編集中の場合、確認メッセージを表示
      this.dialogService.openAlertGetMessage(
        'Q0107',
        ['セット企画プロモーション情報'],
        (closeDetail: number) => {
          if (closeDetail === PlessAlert.Yes) {
            this.parent.editCount = 0;
            this.display();
          } else {
            return;
          }
        }
      );
    } else {
      this.display();
    }
  }

  /**
   * セット企画設定画面を呼び出し、検索結果を表示する
   *
   */
  private display(): void {

    const vo: KYMW1313OutputModel = new KYMW1313OutputModel();
    // 処理区分
    vo.accessDiv = '2';
    // プロモーションＮＯ
    vo.promotionNo = this.dtg_PromotionGoods.selectedItems[0].promotionNo;
    // 呼出元画面に検索条件,選択行を返却する
    this.setKYMW1313Parameter(vo);

    // 閉じる
    this.closeFunction();
  }

  /*--------------------------------------------------------------------------------------------
  /* util area
  /*--------------------------------------------------------------------------------------------*/
  /**
   * プロモーション商品情報取得リクエスト用VO設定
   *
   * @return GetSetPlanPromotionGoodsInfoVO
   */
  private createGetSetPlanPromotionGoodsInfoVO(): KYMW1313GetSetPlanPromotionGoodsInfoModel {

    const vo: KYMW1313GetSetPlanPromotionGoodsInfoModel = new KYMW1313GetSetPlanPromotionGoodsInfoModel();
    // 受注コード
    vo.orderCode = this.kymw1313Model.orderCode;
    // プロモーションＮＯ
    vo.promotionNo = '';
    // プロモーション区分
    vo.promotionDiv = 'S';
    // プロモーション名称
    vo.promotionName = this.kymw1313Model.promotionName;
    // Ｐコード
    vo.pCode = this.kymw1313Model.pCode;
    // セット企画商品名
    vo.setDelivGoodsName = this.kymw1313Model.setDelivGoodsName;
    // 生協コード
    vo.coopCode = this.kymw1313Model.coop;
    // 部門コード
    vo.classCode = this.kymw1313Model.classCode;

    return vo;
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof KYMW1313Component
   */
  public setInterfaceParam(param: any): void {
    this.inputVO = param;
  }
}
